"use strict";

const gtmHelpers = require("../helpers/gtmHelpers");
const accessibleDialog = require("../helpers/accessibleDialog");
const wishlistNotification = require("../wishlist/wishlistNotification");
const { showAddedToWishlistConfirmation } = require("../helpers/wishlistConfirmation");

/**
 * Updates the wishlist icon state and displays confirmation modal
 * @param {Object} data - data returned from the server's ajax call
 * @param {Object} icon - the heart (.js-wishlist-heart) that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
    if (data.success) {
        // Both heart states are in the DOM (product/wishlistIcon.isml); is-filled picks which one shows
        icon.toggleClass("is-filled", data.msg !== "removed");

        if (data.msg !== "removed") {
            if (data.showWishlistModal) {
                showAddedToWishlistConfirmation();
            }
        }
    }
}

/**
* Updates the wishlist heart icon in the header to reflect its active or inactive state.
* Switches between filled and outlined heart icons based on the provided state.
*
* @param {boolean} isListEmpty - Indicates whether the wishlist is active (false for filled heart, true for outlined heart).
*/
function updateHeaderIconState(isListEmpty) {
    if (isListEmpty === undefined) {
        return;
    }

    const wishlistHeader = $(".js-header-wishlist");
    // The header heart is two inline SVGs with one hidden, not a Font Awesome glyph whose
    // class we can swap - so toggle the state on the wrapper instead.
    wishlistHeader.find(".js-wishlist-heart").toggleClass("is-filled", !isListEmpty);

    // DGF-4958: the dot is the low-stock alert for the list as a whole, so it is re-checked whenever the list
    // changes - hidden once the list is empty. It used to be flipped with toggleClass when the list emptied, so it
    // appeared on an empty list and then stayed on through the next add.
    wishlistNotification.refresh();
}

module.exports = {
    addToWishlist: function () {
        $("body").off("click", ".wishlistTile").on("click", ".wishlistTile", function (e) {
            e.preventDefault();
            const icon = $(this).find(".js-wishlist-heart");
            const wishlistUrl = $(this).attr("href");
            let pid = $(this).closest(".product").data("pid");
            if (!pid && $(".pdp-container").length) {
                pid = $(this).closest(".product-detail").length ? $(this).closest(".product-detail").find(".add-to-cart").attr("data-pid") : $(this).closest(".product-tile-pd").attr("data-gtm-product-id");
                if (!pid && $(".notify-me-feature").length) {
                    const closestComingSoon = $(this).closest(".product-detail").find(".subscribe-coming-soon");
                    if (closestComingSoon.length && closestComingSoon.attr("data-pid")) {
                        pid = closestComingSoon.attr("data-pid");
                    } else {
                        pid = $(this).closest(".product-detail").find(".product-name").attr("data-id");
                    }
                }
            } else if (!pid && $(".line-item-header").length) {
                pid = $(this).closest(".line-item-header").find(".remove-product").attr("data-pid");
            } else if ($(this).data("pid")) {
                pid = $(this).data("pid");
            }
            let optionId = $(this).closest(".product-detail").find(".product-option").attr("data-option-id");
            let optionVal = $(this).closest(".product-detail").find(".options-select option:selected").attr("data-value-id");
            optionId = optionId || null;
            optionVal = optionVal || null;

            // update wishlist icon state on PLP if the user adds or removes a product from the wishlist in the quickview modal
            let productTileIcon;
            if (icon.closest(".product-quickview").length) {
                const productTile = pid ? $(`.product[data-pid="${CSS.escape(pid)}"]`) : $();
                productTileIcon = productTile.find(".js-wishlist-heart");
            }
            if (!wishlistUrl || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: wishlistUrl,
                type: "post",
                dataType: "json",
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    $.spinner().stop();
                    // Close through the Quick View module so the dialog helper un-inerts the page,
                    // and before the confirmation opens so that dialog inerts a clean background.
                    if ($(".quick-view-modal").hasClass("show")) {
                        $("body").trigger("product:afterAddToWishlist");
                    }
                    if (data) {
                        displayMessageAndChangeIcon(data, icon);
                        if (productTileIcon && productTileIcon.length) {
                            displayMessageAndChangeIcon(data, productTileIcon);
                        }
                        updateHeaderIconState(data.isListEmpty);
                        gtmHelpers.cartEvents(data.gtmObject);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        $(document).on("click", ".modal.add-to-wishlist", () => {
            // close modal when clicking outside of modal content or on close button
            accessibleDialog.close($(".modal.add-to-wishlist"));
        });
    },
    updateHeaderIconState: updateHeaderIconState,
    updateProductTileIcons: function () {
        const wishListIDs = $(".js-header-wishlist").data("wishlist-ids");
        $(".wishlistTile").each(function () {
            const pid = $(this).data("pid");
            if (!pid) return;
            $(this).find(".js-wishlist-heart").toggleClass("is-filled", Boolean(wishListIDs && wishListIDs.indexOf(pid) > -1));
        });
    }
};
